export var ProductType;
(function (ProductType) {
    ProductType[ProductType["BASIC_PRODUCT"] = 1] = "BASIC_PRODUCT";
    ProductType[ProductType["PACKAGE"] = 2] = "PACKAGE";
    ProductType[ProductType["CERTIFICATION"] = 3] = "CERTIFICATION";
    ProductType[ProductType["APPAREL_CONTAINER"] = 4] = "APPAREL_CONTAINER";
    ProductType[ProductType["APPAREL_VARIANT"] = 5] = "APPAREL_VARIANT";
    ProductType[ProductType["APPAREL_VARIANT_SIZE"] = 6] = "APPAREL_VARIANT_SIZE";
    ProductType[ProductType["DIGITAL"] = 7] = "DIGITAL";
    ProductType[ProductType["GIFT_CARD"] = 8] = "GIFT_CARD";
    ProductType[ProductType["BOOK"] = 9] = "BOOK";
})(ProductType || (ProductType = {}));
//# sourceMappingURL=ProductType.js.map